// utils/lazyWithErrorHandling.js
import React from "react";

export function lazyWithRetry(componentImport) {
  return React.lazy(() =>
    componentImport().catch((error) => {
      console.error("Chunk loading error:", error);

      // Retry once if the initial load fails
      return componentImport().catch((retryError) => {
        console.error("Retry failed:", retryError);

        // Return a fallback component if retry also fails
        return {
          default: () => (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <h3>Failed to load the component</h3>
              <p>Please check your network connection or try again later.</p>
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: "10px 20px",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
              >
                Retry
              </button>
            </div>
          ),
        };
      });
    })
  );
}
